module.exports = __webpack_public_path__ + "static/header-logo-67d04814f31e8b83d7fcc1c2f9e99d46.png";